export const B2B_LOCALE_PREFERENCE_KEY = "b2b-locale-preference";
export const B2B_SESSION_ID_KEY = "b2b-session-value";
export const B2B_CURRENCY_PREFERENCE_KEY = "b2b-currency-preference";
export const LANGUAGE_URL_PARAMETER = "lang";
export const DEV_USE_HTTP_BACKEND = "b2b-use-http-backend";
export const B2B_OVERRIDE_LOCALE = "b2b-locale-override";
